export enum TrailerType {
    Unknown = -1,
    Van = 0,
    VanNoRack = 1,
    Conestoga = 2,
    ConestogaNoRack = 3,
    ConestogaSpreadAxle = 4,
    Gooseneck = 5
}

export const TrailerTypeMetadata = {
    '-1': {
        display: 'Unknown',
        value: -1
    },
    '0': {
        display: '53\' Van',
        value: 0
    },
    '1': {
        display: '53\' Van - No Rack',
        value: 1
    },
    '2': {
        display: '48\' Conestoga',
        value: 2
    },
    '3': {
        display: '48\' Conestoga - No Rack',
        value: 3
    },
    '4': {
        display: 'Spread Axle Conestoga',
        value: 4
    },
    '5': {
        display: 'Gooseneck',   
        value: 5
    }
};
